export const ruleEngineObj = {
  "name": '',
  "condition": {
    "defaulter": {
      "salary": {
        "max": 25000,
        "min": 20000
      },
      "age": {
        "max": 40,
        "min": 30
      },
      "languagesId":[],
    },
    "loan": {
      "dueAmount": {
        "max": 10000,
        "min": 500
      },
      "dueSinceDays": {
        "max": 120,
        "min": 15
      },
      "dueEffort": {
        "max": 100000,
        "min": 1
      },
      "intensity": {
        "min": 0,
        "max": 10,
        "days": {
          "min": 0,
          "max": 10
        }
      }
    },
    "geography": [
      // {
      //   flag: 'city',
      //   values: []
      // },
      // {
      //   flag: 'locality',
      //   values: []
      // },
      // {
      //   flag: 'branch',
      //   values: []
      // },
      // {
      //   flag: 'state',
      //   values: []
      // }
    ],
    "payment": [],
    "responses": {
      "previousResponses": [],
      "lastResponses": {
      }
    },
    "treeId": [],
    "branchId": [],
    "baseConfigId": [],
  },
  "consequence": [
    {
      title: 'Send IVR', label: 'IVR', type: 'ivr'
    },
    {
      title: 'Send Email', label: 'Email', type: 'email',
    },
    {
      title: 'Send SMS', label: 'SMS', type: 'sms',
    },
    {
      title: 'Send Whatsapp', label: 'Whatsapp', type: 'whatsapp',
    }
  ]
}
